/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenPosSessionDto } from '../../models/open-pos-session-dto';
import { PosSession } from '../../models/pos-session';

export interface PosSessionsControllerOpen$Params {
      body: OpenPosSessionDto
}

export function posSessionsControllerOpen(http: HttpClient, rootUrl: string, params: PosSessionsControllerOpen$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSession>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerOpen.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSession>;
    })
  );
}

posSessionsControllerOpen.PATH = '/pos/sessions/open';
